import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import { ValidationSummaryIconContainer } from "./ValidationSummaryIconContainer.js";
import { ValidationSummaryRowContainer } from "./ValidationSummaryRowContainer.js";
function ValidationSummaryRow(props) {
  const { item, testId, hideIcons = false, alignItems, validTextColor, neutralTextColor, invalidTextColor } = props;
  const { uid, iconElement, text, status } = item;
  const color = status === "valid" ? validTextColor : status === "invalid" ? invalidTextColor : neutralTextColor;
  const iconTestId = `validation-summary-icon_${status}`;
  return /* @__PURE__ */ jsx(ValidationSummaryRowContainer, { alignItems, "data-testid": testId, children: /* @__PURE__ */ jsxs(Fragment, { children: [
    !hideIcons && /* @__PURE__ */ jsx(ValidationSummaryIconContainer, { "data-testid": iconTestId, children: iconElement }),
    /* @__PURE__ */ jsx(Typography, { sx: { color }, noWrap: false, variant: "caption", "data-testid": "validation-summary-text", children: text })
  ] }) }, uid);
}
export {
  ValidationSummaryRow
};
//# sourceMappingURL=ValidationSummaryRow.js.map
